import type { AppProductFamily } from '#types/AppTypes'

export interface DeltaPriceRange {
  minDeltaPrice: number
  maxDeltaPrice: number
  // into a range of -1 to 1
  normalizationFactor: number
}

export function calculateDeltaPriceRange(families: AppProductFamily[]) {
  let minDeltaPrice = 0
  let maxDeltaPrice = 0

  for (const family of families) {
    const selectedVariantPrice = family.selectedVariant?.priceData?.price ?? 0

    for (const variant of family.variants) {
      const currentVariantPrice = variant.priceData?.price ?? 0
      const deltaPriceToSelection = currentVariantPrice - selectedVariantPrice
      variant.priceData = {
        price: currentVariantPrice,
        deltaPrice: deltaPriceToSelection,
      }

      if (deltaPriceToSelection < minDeltaPrice) {
        minDeltaPrice = deltaPriceToSelection
      }
      if (deltaPriceToSelection > maxDeltaPrice) {
        maxDeltaPrice = deltaPriceToSelection
      }
    }
  }

  const largestAbsoluteDelta = Math.max(1, Math.abs(minDeltaPrice), Math.abs(maxDeltaPrice))
  const normalizationFactor = 1 / largestAbsoluteDelta

  // MAYBE some day scale logarithmically if the range is too wide?

  return { minDeltaPrice, maxDeltaPrice, normalizationFactor }
}
